import { ecommerceItems, numberValue } from '../utils/ecommerce.js';
import { withEnhancedConversionUserData } from '../utils/enhancedConversions.js';

export default {
    props: {
        nativeAdsDestination: {type: String, default: ''},
        gaMeasurementId: {type: String, default: ''}
    },
    data() {
        return {
        }
    },
    async mounted() {
        if (this.fuelEnv === 'production' && this.order?.status === 'Successful' && String(this.order?.reference || '').trim() && this.$gtag) {
            // GA4 Enhanced Ecommerce purchase event (+ Enhanced Conversions user_data when consented)
            const purchaseParams = await withEnhancedConversionUserData({
                "transaction_id": this.order?.reference ? this.order.reference : '',
                "affiliation": this.webName ? this.webName : '',
                "value": numberValue(this.order?.total) || 0.00,
                "currency": "GBP",
                "tax": numberValue(this.order?.tax) || 0.00,
                "coupon": this.order?.discount_codes ? this.order.discount_codes : '',
                "shipping": numberValue(this.order?.delivery_amount) || 0.00,
                "items": this.purchasedItems
            }, this.order);

            if (typeof this.order?.new_customer === 'boolean')
            {
                purchaseParams.new_customer = this.order.new_customer;
                purchaseParams.customer_type = this.order.new_customer ? 'new' : 'returning';
            }

            if (this.nativeAdsDestination && this.gaMeasurementId)
            {
                // A purchase routed to an Ads label supports cart data; no second conversion event.
                purchaseParams.send_to = [this.gaMeasurementId, this.nativeAdsDestination];
                purchaseParams.items = purchaseParams.items.map(item => ({...item, id: item.item_id}));
            }
            // Set the consent-filtered matching data before the purchase reaches Ads.
            this.$gtag.set?.('user_data', purchaseParams.user_data || {});
            this.$gtag.event('purchase', purchaseParams);
        }

        // PriceShape API (Send Sale)
        window.PRICESHAPE = window.PRICESHAPE || [];
        _.forEach(this.order?.products, function(product, key) {
            if(product.product_type === 'product') {
                window.PRICESHAPE.itemsSold([
                    { upi: String(product.st_code), itemsSold: product.quantity, uniqueSales: 1},
                ])
            }
        });
    },
    methods: {
        trackFailure() {
            
        }
    },
    computed: {
        purchasedItems() {
            return ecommerceItems(this.order);
        }
    }
};
